import { render, staticRenderFns } from "./FuelsAndElectricity.vue?vue&type=template&id=640ab523"
import script from "./FuelsAndElectricity.vue?vue&type=script&lang=js"
export * from "./FuelsAndElectricity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports